import React, { useState, useEffect } from "react";
import ShieldIcon from "./shield.png";
import LinkIcon from "./link.png";
import GearIcon from "./gear.png";
import LockIcon from "./lock.png";
import ScalesIcon from "./scale.png";
import FolderIcon from "./folder.png";

const WhyLibertusSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const comparisons = [
    {
      icon: <img src={LockIcon} alt="Cloud Act Trap" className="icon" />,
      heading: "The CLOUD Act Trap: US law owns your Canadian data",
      subheading: "Even when stored in Canada, your data is vulnerable to foreign access, compromising national sovereignty and privacy.",
      points: [
        "**Microsoft Confirmed:** U.S. requests for data override Canadian law, even for data hosted in Canada.",
        "**Zero Notification:** U.S. authorities are not required to notify you or Canadian authorities of data access.",
        "**Universal Exposure:** This affects all U.S. cloud providers, including OpenAI, Google, Amazon, and Anthropic.",
        "**Government Advisory:** The Government of Canada states, \"We cannot ensure full sovereignty\" over data held by foreign entities.",
      ],
    },
    {
      icon: <img src={LinkIcon} alt="AI Providers Watching" className="icon" />,
      heading: "AI Providers Are Watching: Your conversations aren't private",
      subheading: "Recent policy changes reveal major AI providers actively monitor and utilize your sensitive business discussions.",
      points: [
        "**Active Scanning:** ChatGPT actively scans all conversations for \"threats\" and policy violations.",
        "**Law Enforcement Reporting:** Providers may report activities to law enforcement without your knowledge or consent.",
        "**Massive Data Requests:** Microsoft alone reported over 5,560 government data requests in just six months, impacting countless organizations.",
        "**Training Data Exploitation:** Your sensitive business discussions, strategies, and intellectual property can become training data for their models.",
      ],
    },
    {
      icon: <img src={ShieldIcon} alt="Breach Epidemic" className="icon" />,
      heading: "The Breach Epidemic: $9.28M average cost in financial services",
      subheading: "Data breaches are escalating, with severe financial and reputational consequences for businesses across all sectors.",
      points: [
        "**Healthcare Crisis:** 5 Ontario hospitals experienced data exposure affecting 326,000 patients in 2023, leading to significant recovery costs.",
        "**Detection Lag:** On average, it takes 168 days to detect a data breach, extending exposure and increasing damage.",
        "**Automatic Class Actions:** High-profile breaches, like 23andMe's $3.25M settlement, trigger automatic class action lawsuits, increasing legal burden.",
        "**Reputation Destruction:** A single headline reporting a data breach can irrevocably damage your organization's trust and market standing.",
      ],
    },
    {
      icon: <img src={ScalesIcon} alt="Compliance Penalties" className="icon" />,
      heading: "Compliance Penalties Explode: Fines that end businesses",
      subheading: "Regulatory bodies are enforcing privacy laws with unprecedented strictness, imposing fines that can cripple or dissolve organizations.",
      points: [
        "**PHIPA Violations:** Penalties can reach $1M for organizations and $200K for personal liability under PHIPA.",
        "**Quebec's Law 25:** Quebec's privacy law imposes fines of up to $25M or 4% of global revenue, among the strictest globally.",
        "**PIPEDA Investigations:** Federal investigations under PIPEDA lead to public shaming and significant legal and reputational fallout.",
        "**Mandatory Reporting:** Every breach mandates reporting, triggering investigations and almost guaranteed lawsuits, amplifying financial and operational stress.",
      ],
    },
  ];

  return (
    <div id="the-risk-reality" className="section-container text-dark section-padding">
      <div className="text-center margin-bottom-50">
        <h2 className="section-title text-dark font-weight-700">
          Every Cloud AI Query is a Compliance Time Bomb: Protect Your Business from Unseen Threats
        </h2>
        <p className="section-description text-medium-gray line-height-1-5">
          In today's digital landscape, relying on major cloud AI providers exposes your organization to significant, often hidden, risks. These providers routinely scan your data, may report to authorities under foreign laws, and operate outside Canadian sovereignty. This section details the critical compliance and security threats that make every cloud AI query a potential liability. Understand the real stakes and how to mitigate them.
        </p>
      </div>

      <div className="resource-card">
        {comparisons.map((comp, index) => (
          <div key={index} className={`resource-card-light-bg card-animation-on-load ${isVisible ? 'is-visible' : ''}`}>
            <div className="resource-card-light-bg-icon">
              {comp.icon}
            </div>
            <h3 className="resource-card-light-bg-title">{comp.heading}</h3>
            <p className="resource-card-light-bg-description">
              {comp.subheading}
            </p>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {comp.points.map((point, pointIndex) => (
                <li
                  key={pointIndex}
                  className="detail-item"
                >
                  <span dangerouslySetInnerHTML={{ __html: point.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }} />
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyLibertusSection;